<template>
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\achievementStudentManual-1.png" alt="" /></div>
                <div>
                    <p>① Ở màn hình khái quát khóa học, nhấn nút [Xác nhận tiến độ], rồi di chuyển đến màn hình Xác nhận tiến độ.</p>
                </div>
                <div><img src="/static\images\vi\newManual\achievementStudentManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhập điều kiện tìm kiếm, nhấn nút [Tìm kiếm], rồi xác nhận kết quả tìm kiếm.</p>
                    <p>③ Nhấn nút [Xuất file], thì kết quả tìm kiếm sẽ được xuất ra dưới dạng file Excel.</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Ở màn hình chi tiết khóa học, nhấn nút [Xác nhận tiến độ], rồi di chuyển đến màn hình Xác nhận tiến độ.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\student_achievements_1.png" alt="" /></div>
                <div><p>② Hiển thị màn hình thành tích học viên.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\student_achievements_2.png" alt="" /></div>
                <div><p>③ Nhập điều kiện tìm kiếm và nhấn nút [Tìm kiếm] để hiển thị danh sách bạn muốn tìm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\student_achievements_3.png" alt="" /></div>
                <div><p>④ Nhấn vào email học viên để xem thông tin của học viên đó.</p></div>
                <div><p>● Lớp học thêm: têm của lớp học thêm đó.</p></div>
                <div><p>● Lớp học trực thuộc: Lớp hiện tại đang học.</p></div>
                <div><p>● Ngày rời khóa học: Ngày học viên đó rời khỏi khóa học.</p></div>
                <div><p>● Tiến độ học tập: Tiến độ học viên đó hoàn thành khóa học.</p></div>
                <div><p>● Tên kì thi: Tên kì thi học viên đó đã thi.</p></div>
                <div><p>● Điểm thi mới nhất: Điểm thi mới nhất của học viên đó thi được.</p></div>
                <div><p>● Đánh giá: Đánh giá thành tích của học viên đó trong kì thi đậu hay không đậu.</p></div>
                <div><p>● Thời gian làm bài thi: Thời gian học viên đó thi được.</p></div>
                <div><p>● Thời gian bắt đầu thi: Thời gian học viên đó bắt đầu thi.</p></div>
                <div><p>● Thời gian kết thúc thi: Thời gian học viên đó nộp bài thi.</p></div>
                <div><p>● Ngày bắt đầu: ngày học viên đó bắt đầu tham gia khóa học.</p></div>
                <div><p>● Ngày kết thúc: Ngày học viên đó yêu cầu kết thúc khóa học.</p></div>
                <div><p>● Số chương đã học: Số chương học viên đó đã học.</p></div>
                <div><p>● Số chương chưa học: Số chương học viên đó chưa học.</p></div>
                <div><p>● Bản cam kết.</p></div>
                <div><p>● Bảng khảo sát.</p></div>
                <div><p>● Yêu cầu kết thúc.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\student_achievements_4.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {},
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/achievementStudent_manual.vue